import ServerSettings from './ServerSettings';

export default ServerSettings;
